"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeUndefined = exports.addKeysToValues = void 0;
function addKeysToValues(obj, keyField = "id") {
    return Object.fromEntries(Object.entries(obj).map(([key, val]) => [
        key,
        Object.assign({ [keyField]: key }, val),
    ]));
}
exports.addKeysToValues = addKeysToValues;
/**
 * Note: This method modifies the original object.
 */
function removeUndefined(obj) {
    for (let prop in obj) {
        if (obj[prop] === undefined) {
            delete obj[prop];
        }
    }
    return obj;
}
exports.removeUndefined = removeUndefined;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2JqZWN0VXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL29iamVjdFV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLFNBQWdCLGVBQWUsQ0FBQyxHQUFXLEVBQUUsV0FBbUIsSUFBSTtJQUNsRSxPQUFPLE1BQU0sQ0FBQyxXQUFXLENBQ3ZCLE1BQU0sQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDLEVBQUUsRUFBRSxDQUFDO1FBQ3RDLEdBQUc7d0JBRUQsQ0FBQyxRQUFRLENBQUMsRUFBRSxHQUFHLElBQ1osR0FBRztLQUVULENBQUMsQ0FDSCxDQUFDO0FBQ0osQ0FBQztBQVZELDBDQVVDO0FBRUQ7O0dBRUc7QUFDSCxTQUFnQixlQUFlLENBQW1CLEdBQU07SUFDdEQsS0FBSyxJQUFJLElBQUksSUFBSSxHQUFHLEVBQUU7UUFDcEIsSUFBSSxHQUFHLENBQUMsSUFBSSxDQUFDLEtBQUssU0FBUyxFQUFFO1lBQzNCLE9BQU8sR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ2xCO0tBQ0Y7SUFDRCxPQUFPLEdBQUcsQ0FBQztBQUNiLENBQUM7QUFQRCwwQ0FPQyJ9